/**
 *
 * In a string, replace all text formatted like
 * [link label text](url) into a tags, setting target="_blank"
 * only if the link is an absolute URL.
 */
export const convertMarkdownStyleHyperlinksToHtml = (inputString = '') => {
  if (!inputString) {
    return '';
  }

  return inputString.replaceAll(
    /\[([^\]]+)\]\((https?:\/\/[^)]+|\/[^)]+)\)/g,
    (_, label, url) => {
      // Check if the URL is absolute or relative
      const isAbsoluteUrl = /^https?:\/\//.test(url);
      const targetAttr = isAbsoluteUrl
        ? 'target="_blank" rel="noreferrer noopener"'
        : '';

      return `<a href="${url}" ${targetAttr}>${label}</a>`;
    },
  );
};
